/*** IMPORTS FROM imports-loader ***/


module.exports = {

    title: "Mystic Force",
    theme: "mf",
    baseMultiplier: 2,
    maxPrize: 8,

    font: "ProximaNova",
    fontVariations: ":n4,n7",
    secondaryFont: "SignPainter",

    hasButtonImage: true,
    blurMenuBg: false,
    bigWinStartingPrizeId: 5,

    backgroundAnchorX: 0,
    backgroundAnchorY: 0.5,

    hasMultiplier: true,
    hasBackgroundView: true,

    donePercent: 60,
    brushSize: 100,
    scratchY: 90,
    prizeScale: 1,
    prizeTextY: 35,

    showLogoInGame: true,
    logoYInGame: 10,
    logoYTitle: 240,
    logoZTitle: 3,
    logoFromBottomTitle: true,

    showCharacter: true,
    characterX: 40,
    characterY: 500,
    characterZ: 1,

    showBottomGradient: true,
    bottomGradientZ: 2,

    ticketIdX: 10,

    titleLossY: 230,

    winSign: 'movie',
    winSignTextY: 45,
    winSignTextMaxWidth: 220,
    winSignTextMaxFontSize: 50,
    winSignYOffset: 20,

    bgColor: 0x356c61,
    primaryColor: 0xfcb62e,

    images: {

        brush: "brush.png",

        bgs: {
            scratched: "scratch_bg.png",
            unscratched: "scratch.png"
        },

        prizes: {
            1: "1|1",  // 2€ x 1 = 2€
            2: "1|2",  // 2€ x 2 = 4€
            3: "2|1",  // 4€ x 1 = 4€
            4: "2|2",  // 4€ x 2 = 8€
            5: "1|5",  // 2€ x 5 = 10€
            6: "1|10", // 2€ x 10 = 20€
            7: "2|5",  // 4€ x 5 = 20€
            8: "3|1",  // 20€ x 1 = 20€
            9: "2|10", // 4€ x 10 = 40€
            10: "3|2",  // 20€ x 2 = 40€
            11: "3|5",  // 20€ x 5 = 100€
            12: "4|1",  // 100€ x 1 = 100€
            13: "3|10", // 20€ x 10 = 200€
            14: "4|2",  // 100€ x 2 = 200€
            15: "5|1",  // 400€ x 1 = 400€
            16: "4|5",  // 100€ x 5 = 500€
            17: "5|2",  // 400€ x 2 = 800€
            18: "4|10", // 100€ x 10 = 1000€
            19: "5|5",  // 400€ x 5 = 2000€
            20: "5|10", // 400€ x 10 = 4000€
            21: "6|1",  // 4000€ x 1 = 4000€
            22: "6|2",  // 4000€ x 2 = 8000€
            23: "6|5",  // 4000€ x 5 = 20000€
            24: "7|1",  // 20000€ x 1 = 20000€
            25: "7|2",  // 20000€ x 2 = 40000€
            26: "6|10", // 4000€ x 10 = 40000€
            27: "7|5",  // 20000€ x 5 = 100000€
            28: "8|1",  // 100000€ x 1 = 100000€
            29: "7|10", // 20000€ x 10 = 200000€
            30: "8|2",  // 100000€ x 2 = 200000€
            31: "8|5",  // 100000€ x 5 = 500000€
            32: "8|10"  // 100000€ x 10 = 1000000€
        }
    },

    sounds: {
        volumes: {
            click: 0.3,
            music: 0.08,
            reveal: 0.5,
            bigWin: 0.4,
            win: 0.4,
            loss: 0.4
        },
        prizes: {
            1: "win-2",
            2: "win-2",
            3: "win-2",
            4: "win-2",
            5: "win-2",
            6: "win-2",
            7: "win-2",
            8: "win-2",
            9: "win-2",
            10: "win-2",
            11: "win-3",
            12: "win-3",
            13: "win-3",
            14: "win-3",
            15: "win-3",
            16: "win-3",
            17: "win-3",
            18: "win-3",
            19: "win-3",
            20: "win-4",
            21: "win-4",
            22: "win-4",
            23: "win-4",
            24: "win-4",
            25: "win-4",
            26: "win-4",
            27: "win-4",
            28: "win-4",
            29: "win-4",
            30: "win-4",
            31: "win-4",
            32: "win-4",
        }
    },

    styles: {
        prize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fontWeight: 100,
            fill: "#FEE9FF",
            align: "center",
            lineHeight: 25,
            stroke: '#0F0E33',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        maxPrize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fontWeight: 100,
            fill: "#D9C82C",
            align: "center",
            lineHeight: 25,
            stroke: '#0F0E33',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        introText: {
            fontFamily: "ProximaNova",
            fontSize: 16,
            fontWeight: 100,
            fill: "#FFFFFF",
            align: "center",
            lineHeight: 23,
            wordWrap: true,
            wordWrapWidth: 260,
            stroke: '#3F082D',
            strokeThickness: 3,
            lineJoin: 'round',
            dropShadow: false,
            dropShadowBlur: 3,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2,
            dropShadowDistance: 2
        }
    },

    positions: {
        points:[
            {
                x:0.24,
                y:0.21
            },
            {
                x:0.50,
                y:0.21
            },
            {
                x:0.76,
                y:0.21
            },
            {
                x:0.24,
                y:0.48
            },
            {
                x:0.76,
                y:0.48
            },
            {
                x:0.24,
                y:0.75
            },
            {
                x:0.50,
                y:0.75
            },
            {
                x:0.76,
                y:0.75
            }
        ],
        multiplier:{
            x:0.50,
            y:0.48
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./themes/mf/config.js
// module id = 50
// module chunks = 4